<template>
    <section class="message">
        <div class="modal">
            <div class="modal-icon">
                <img :src="'images/' + modalIcon" alt="Ikona">
            </div>
            <h3 v-if="title">{{ title }}</h3>
            <div class="modal-content">
                <div v-html="content"></div>
                <slot></slot>
                <button 
                    v-for="(btn, i) in buttons" 
                    :key="i"
                    class="btn btn-primary"
                    @click="btnClick()"
                    type="button">
                    {{ btn.text }}
                </button>
            </div>
        </div>
        <div class="backdrop"></div>
    </section>
</template>

<script>
export default {
    props: {
        modalIcon: {
            type: String,
            required: false,
            default: 'modal-info.svg'
        },
        title: {
            type: String,
            required: false,
            default: ''
        },
        content: {
            type: String,
            required: false
        },
        buttons: {
            type: Array,
            required: false,
            default: function() {
                return []
            }
        }
    },
    methods:{
        btnClick(){
            this.$emit('btnClick')
        }
    }
}
</script>